/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getByIdEarlyRequestRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.noauth.ShortPublicChirpService',
  rpcName: 'getById',
  auth: 'external',
  fingerprint: '5KRAr87mEkkAkmdAkFdyQpwP6LXzGzX8',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};